import React from "react";
import Layout from "components/Layout";
import Map from "./components/HomeMap";

function HomeMap() {
  return (
    <Layout title="장치 지도">
      <Map />
    </Layout>
  );
}

export default HomeMap;
